export const selectExternalRegistrationId = ({ registration }) =>
  registration?.externalId;
